import APP_ROUTES from "app/constants/routes/app";
import { getQueryParams } from "app/hooks/useCustomNavigation";
import { getItem, setItem } from "app/utils/session";
import { Redirect, Route } from "react-router";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const isAuthenticated = getItem("token");

    if (!isAuthenticated) {
        if (getQueryParams('jobId')) {
            setItem("jobRedirection", `${window.location.pathname}${window.location.search}`);
            return <Redirect to={APP_ROUTES.LOGIN} />;
        }
    };
    return <Route {...rest} component={Component} />;
};

export default PrivateRoute;
